<template>
  <nav-bar title="举报信息" />
  <Content :bottom="0" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="information-list">
      <li v-for="item in list" :key="item.reportId" class="information-list-item" @click="handleItemClick(item)">
        {{item.reportTime}}  {{item.title}}
      </li>
    </ul>
    <!-- 加载更多 -->
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="reload" />
  </Content>
  <Popup ref="popup" :title="title">
    <p class="text">{{reportTime}}</p>
    <p class="text">{{content}}</p>
  </Popup>
</template>

<script>
import { ref, reactive, toRefs } from 'vue'
import { reportList } from '@/api/list'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'ReportInformation',
  setup () {
    // const data = useLoadingMore(reportList)
    // const {
    //   getList,
    //   list,
    //   finished,
    //   loadingFail,
    //   pageParams
    // } = data
    // pageParams.page = 1
    // finished.value = false
    // loadingFail.value = false
    // getList()
    // 初始化list

    // 初始化list

    const list = ref([])
    useGetData(reportList, (data) => {
      list.value = data.rows
    })({ tenantId: localStorage.getItem('tenant_id') || '' })
    // 举报详情
    const popup = ref(null)
    const detail = reactive({
      title: '',
      reportTime: '',
      content: ''
    })
    const handleItemClick = ({ title, content, reportTime }) => {
      detail.title = title
      detail.reportTime = reportTime
      detail.content = content
      popup.value.show = true
    }
    return {
      ...toRefs(detail),
      popup,
      handleItemClick,
      list
    }
  }
}
</script>

<style lang="scss" scoped>
.information-list {
  padding:16px 16px 0 16px;
  .information-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
  }
}
.text {
  font-size: 14px;
  text-indent: 24px;
  color: #666;
}
</style>
